// extracted by mini-css-extract-plugin
export var WelcomeOverlay = "V_dl";
export var aniBgLoading = "V_f";
export var aniSpin = "V_d";
export var bg = "V_0";
export var body = "V_bp";
export var bodyText = "V_dq";
export var close = "V_dn";
export var closeButton = "V_dr";
export var grid = "V_H";
export var head = "V_dp";
export var header = "V_B";
export var header__inner = "V_bm";
export var heading = "V_C";
export var inner = "V_g";
export var scroll = "V_dm";